<script>
import Sidebar from '~lib/src/layouts/sidebar';

export default {
  extends: Sidebar,
};
</script>
